import { render } from "./AccountAuthTableView.vue?vue&type=template&id=67bc9b65"
import script from "./AccountAuthTableView.vue?vue&type=script&lang=js"
export * from "./AccountAuthTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__